// This file was auto-generated by Fern from our API Definition.
const WebhookHttpMethodValues = {
    Get: "GET",
    Post: "POST",
};
export const WebhookHttpMethod = Object.assign(Object.assign({}, WebhookHttpMethodValues), { _visit: (value, visitor) => {
        switch (value) {
            case WebhookHttpMethod.Get:
                return visitor.get();
            case WebhookHttpMethod.Post:
                return visitor.post();
            default:
                return visitor._other();
        }
    } });
